<template>
  <div class="financial-year-quarter-selector">
    <strong>Financial Year</strong>
    <q-option-group
      :model-value="selectedFinancialYear"
      :options="financialYears"
      type="radio"
      @update:model-value="$emit('update:selectedFinancialYear', $event)"
    />

    <strong v-if="showQuarter">Quarter</strong>
    <q-option-group
      v-if="showQuarter"
      :model-value="selectedQuarter"
      :options="quarterOptions"
      type="radio"
      @update:model-value="$emit('update:selectedQuarter', $event)"
    />
  </div>
</template>

<script>
export default {
  name: "FinancialYearQuarterSelector",
  props: {
    selectedFinancialYear: {
      type: Number,
      required: true
    },
    selectedQuarter: {
      type: Number,
      required: false
    },
    financialYears: {
      type: Array,
      required: true
    },
    quarterOptions: {
      type: Array,
      required: true
    },
    showQuarter: {
      type: Boolean,
      required: true
    }
  },
  emits: ["update:selectedFinancialYear", "update:selectedQuarter"]
}
</script>

<style lang="css" scoped>
.financial-year-quarter-selector {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
